import axios from 'axios/index';
import config from '../../../../config/sbf_config';

export const bikeFind = (vrm) => (
    axios({
        method: 'get',
        url: `${config.bikelookup}/bike/lookup?vrm=${vrm}&source=purchasingLookup`,
    }).then((response) => response.data).catch((error) => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/requests/bike_find_request.js